import {Component} from '@angular/core';

@Component({
    selector: 'app-constitution',
    templateUrl: './constitution.component.html',
    styleUrl: './constitution.component.css',
})
export class ConstitutionComponent {
    zoomLevel: number = 1.2;
}
